import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const CODELESS_CONVERSION_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.CODELESS_EVENT_TOOL]}`;
export const CODELESS_CONVERSION_ID_PARAM_NAME = 'codelessConversionId';
export const CODELESS_CONVERSION_ID_PARAM_TEMPLATE = `/:${CODELESS_CONVERSION_ID_PARAM_NAME}?`;
